import { render, staticRenderFns } from "./OptimizacionProduccion.vue?vue&type=template&id=12139270&scoped=true&"
import script from "./OptimizacionProduccion.vue?vue&type=script&lang=js&"
export * from "./OptimizacionProduccion.vue?vue&type=script&lang=js&"
import style0 from "./OptimizacionProduccion.vue?vue&type=style&index=0&id=12139270&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12139270",
  null
  
)

export default component.exports